import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import { isEmpty } from '../../../Common/Common';

import FcuOperation from './FcuOperation';
import DehumiOperation from './DehumiOperation';
import SwitchOperation from './SwitchOperation';
import ShutterOperation from './ShutterOperation';
import RGBWOperation from './RGBWOperation';
import GeneralOperation from './GeneralOperation';
import HrvOperation from './HrvOperation';

export default class Group_Operation_Screen extends Component {
	constructor(props) {
		super(props);
		// For each unique mp type, add into array 
		this.group_types = [];
		this.tab_types = {};
		this.tab_types.general = false; //Indicator to display General tab
		this.tab_types.Ac = false; //Indicator to display Ac tab
		this.tab_types.Hrv = false; //Indicator to display hrv tab
		this.tab_types.others = false; //Indicator to display others tab
		let count = 0;
		for (let point_id of this.props.param.group_info.mp) {
			let point_info = window.app.state.point_list[point_id];
			if (!isEmpty(point_info)) {
				if (!this.group_types.includes(point_info.type)) {
					this.group_types.push(point_info.type);
					//If group have one of these types, the default selected tab is general
					if (point_info.type == 'Ac' || point_info.type == 'Dehumi' 
						|| point_info.type == 'LevelSw' || point_info.type == 'Rgbw' 
						|| point_info.type == 'Switch' || point_info.type == 'Hrv') {
						this.tab_types.general = true;
						count++;
					}

					if (point_info.type == 'Ac') {
						this.tab_types.Ac = true;
						count++;
					}

					if (point_info.type == 'Hrv') {
						this.tab_types.Hrv = true;
						count++;
					}

					if (point_info.type == 'Shutter' || point_info.type == 'Rgbw') {
						this.tab_types.others = true;
						count++;
					}
				}
			}
		}

		this.tab_types.count = count; //Count the number of tabs

		//Set default tab
		let tab = "";
		if (this.tab_types.general) {
			tab = 'general';
		} else if (this.tab_types.Ac) {
			tab = 'Ac';
		} else if (this.tab_types.Hrv) {
			tab = 'Hrv';
		} else if (this.tab_types.others) {
			tab = 'others';
		}

		this.state = {
			tab: tab
		}

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
	}

	handlePrevious = () => {
		let from = this.props.param.from
		if (from == 'Group_Details') {
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			from = this.props.param.group_detail_from;
			this.props.content_handler(this.props.param.from, { from: this.props.param.group_detail_from, group_info: this.props.param.group_info, group_id: this.props.param.group_id });
		}
	}

	rcvExec = (response) => {

	}

	handleShowCommands = (tab) => {
		this.setState({ tab: tab })
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto'
		}

		// To determine the width of each tab
		let tab_width = 100;
		tab_width = tab_width / this.tab_types.count;
		tab_width = tab_width + "%";

		// To determine the which content to display
		let dynamic_content = null;

		switch (this.state.tab) {
			case 'general':
				dynamic_content =
					<div>
						<GeneralOperation
							point_id={null} // use group id to send command instead
							point_info={null}
							receiver={this.props.receiver}
							width={this.props.width}
							height={this.props.height}
							group_info={this.props.param.group_info}
							group_id={this.props.param.group_id}
						/>
					</div>
				break;
			case 'Ac':
				dynamic_content =
					<div>
						<FcuOperation
							point_id={null} // use group id to send command instead
							point_info={null}
							receiver={this.props.receiver}
							width={this.props.width}
							height={this.props.height}
							group_info={this.props.param.group_info}
							group_id={this.props.param.group_id}
						/>
					</div>
				break;
			case 'Dehumi':
				dynamic_content =
					<div>
						<DehumiOperation
							point_id={null} // use group id to send command instead
							point_info={null}
							receiver={this.props.receiver}
							width={this.props.width}
							height={this.props.height}
							group_info={this.props.param.group_info}
							group_id={this.props.param.group_id}
						/>
					</div>
				break;
			case 'Hrv':
				dynamic_content =
					<HrvOperation
						point_id={null}
						point_info={null}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						group_info={this.props.param.group_info}
						group_id={this.props.param.group_id}
					/>
				break;
			case 'others':
				dynamic_content =
					<div>
						{this.group_types.includes("Shutter") ? <ShutterOperation
							point_id={null} // use group id to send command instead
							point_info={null}
							receiver={this.props.receiver}
							width={this.props.width}
							height={this.props.height}
							group_info={this.props.param.group_info}
							group_id={this.props.param.group_id} /> : null}

						{this.group_types.includes("Rgbw") ? <RGBWOperation
							point_id={null} // use group id to send command instead
							point_info={null}
							receiver={this.props.receiver}
							width={this.props.width}
							height={this.props.height}
							group_info={this.props.param.group_info}
							group_id={this.props.param.group_id} /> : null}
					</div>
				break;
			default:
		}

		let colours = window.app.state.colours;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('group_operation')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ width: '100%', padding: 0, marginTop: 20, display: 'table', }}>
						<span style={{ cursor: 'pointer', display: this.tab_types.general ? 'table-cell' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, width: tab_width, padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'general' ? colours.appBlue : 'white', color: this.state.tab == 'general' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('general')}>{this.props.receiver.getString('general')}</span>
						<span style={{ cursor: 'pointer', display: this.tab_types.Ac ? 'table-cell' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, width: tab_width, padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'Ac' ? colours.appBlue : 'white', color: this.state.tab == 'Ac' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('Ac')}>{this.props.receiver.getString('ac')}</span>
						<span style={{ cursor: 'pointer', display: this.tab_types.Hrv ? 'table-cell' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, width: tab_width, padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'Hrv' ? colours.appBlue : 'white', color: this.state.tab == 'Hrv' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('Hrv')}>{this.props.receiver.getString('hrv')}</span>
						<span style={{ cursor: 'pointer', display: this.tab_types.others ? 'table-cell' : 'none', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, width: tab_width, padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'others' ? colours.appBlue : 'white', color: this.state.tab == 'others' ? 'white' : 'black' }} onClick={() => this.handleShowCommands('others')}>{this.props.receiver.getString('others')}</span>
					</div>
					{dynamic_content}
				</div>
			</div>
		)
	}
}